import BaseComponent from './BaseComponent';
import SearchAutocomplete from './SearchAutocomplete';
import $ from 'jquery';

class ClientSelector extends BaseComponent {

    constructor(props){
		super(props);
		this.close = this.close.bind(this);
		this.assignCallback = this.assignCallback.bind(this);
		this.renderButtons = this.renderButtons.bind(this);
    	this.renderClientsFilter = this.renderClientsFilter.bind(this);
    	this.changeClientsHandler = this.changeClientsHandler.bind(this);
    	this.getClientsCallback = this.getClientsCallback.bind(this);
    	this.clientSelected = this.clientSelected.bind(this);
    	this.setCurrentSelection = this.setCurrentSelection.bind(this);

		this.state = {
			clientsFromApi: [],
			currentSelection: 0
		};

		let api = this.getApi();

		api.getClients([],this.getClientsCallback);
    }

    getClientsCallback(response){
		if(response.status === 'OK'){
				const clients = response.clients.map(cli => {
				cli.completeName = cli.name+' '+cli.lastname;
				return cli;
			});

			this.setState(prevState => {
				return {
					...prevState,
						clientsFromApi: clients
				}
			});
		}
    }

    close(){
		$("#client-selector-component").modal('toggle');
    }

    assignCallback(button){
		if(button.close && button.close) this.close();
		if(button.callback) button.callback();
    }

    render() {
    	return (
		<div className="modal fade" id="client-selector-component" tabIndex="-1" role="dialog" 
			aria-labelledby="ModalTitleLabel" aria-hidden="true">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="ModalTitleLabel">
							Seleccione cliente
						</h5>
						<button type="button" className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						<>
    							{this.renderClientsFilter()}
						</>
					</div>
					<div className="modal-footer">
						{this.renderButtons()}
					</div>
				</div>
			</div>
		</div>
        )
    }

    renderClientsFilter(){
		return this.state.clientsFromApi?
			<div className="row">
				<div className="col-3">
					Seleccione un cliente
				</div>
				<div className="col-9">
					<SearchAutocomplete data={this.state.clientsFromApi} selected={this.state.currentSelection}
						lookFor={'completeName'} displayField={'completeName'} 
						onOptionSelected={this.changeClientsHandler}/>
				</div>
			</div>
		:undefined
    }

    addCompleteName(clients, onlyOneElement){
    	if(clients === null) return [];
    	if(onlyOneElement) clients = [clients];
		clients = clients.map?clients.map(client => {
			client.completeName = client.name+' '+client.lastname
			return client;
		}):[];

		return onlyOneElement?clients.pop():clients;
    }

    setCurrentSelection(selection){
		this.setState(prevState => {
			return {
				...prevState,
					currentSelection: selection!== undefined?this.addCompleteName(selection, true):0
			}
		});
    }

    clientSelected(){
    	const returnedValue = this.state.selectedClients && this.state.selectedClients.clients && this.state.selectedClients.clients.length > 0?this.state.selectedClients:null;
		this.props.onClientSelected(returnedValue);
    }

    renderButtons(){
    	const buttons = [
		{shown: 'Aplicar', close: true, callback: this.clientSelected, behaviour: 'main'},
		{shown: 'Cerrar', close: true}
	];
	return buttons.map( (button,idx) => {
		return (<button type="button" key={"modal_btn_"+idx}
			className={button.behaviour === 'main'?"btn btn-primary":"btn btn-secondary"} 
			data-dismiss={button.close === true?"modal":undefined}
			onClick={this.assignCallback.bind(this,button)}>
			{button.shown}
		</button>)
	})
    }

    changeClientsHandler(elem){
    	let selectedClients = {};
    	selectedClients.clients = [elem];

		this.setState(prevState => {
			return {
				...prevState,
					selectedClients: selectedClients
			}
		});
    }
}

export default ClientSelector;
